/**
 * 문항 카드 AI 액션 카피. 호출부는 전부 이 모양만 참조한다 — 사유 키(EligibilityReason)로
 * `copy.reason[reason]` 처럼 바로 찾을 수 있게 i18n 키 구조와 같은 모양을 유지한다.
 */
import { type TFunction } from 'i18next';
import { useTranslation } from 'next-i18next';

export const createQuestionCardAiCopy = (t: TFunction<['build']>) => ({
  trigger: t('build:build.questionCardAi.trigger'),
  menu: {
    similar: t('build:build.questionCardAi.menu.similar'),
    harder: t('build:build.questionCardAi.menu.harder'),
    fillOptions: t('build:build.questionCardAi.menu.fillOptions'),
    /** 단답형 — 선택할 선지가 없다. 인정 답안을 채운다는 뜻으로 읽혀야 한다. */
    fillAnswers: t('build:build.questionCardAi.menu.fillAnswers'),
    chat: t('build:build.questionCardAi.menu.chat'),
  },
  reason: {
    unsupportedType: t('build:build.questionCardAi.reason.unsupportedType'),
    imageNotSupported: t('build:build.questionCardAi.reason.imageNotSupported'),
    emptyQuestion: t('build:build.questionCardAi.reason.emptyQuestion'),
    quizLimit: t('build:build.questionCardAi.reason.quizLimit'),
    noEmptySlots: t('build:build.questionCardAi.reason.noEmptySlots'),
    noEmptyAnswers: t('build:build.questionCardAi.reason.noEmptyAnswers'),
    running: t('build:build.questionCardAi.reason.running'),
  },
  status: {
    similar: t('build:build.questionCardAi.status.similar'),
    similarFailed: t('build:build.questionCardAi.status.similarFailed'),
  },
  error: {
    /** 선지 채움 실패 알럿의 일반 사유 문구. */
    title: t('build:build.questionCardAi.error.title'),
    retry: t('build:build.questionCardAi.error.retry'),
  },
});

export type QuestionCardAiCopy = ReturnType<typeof createQuestionCardAiCopy>;

export const useQuestionCardAiCopy = (): QuestionCardAiCopy => {
  const { t } = useTranslation(['build']);
  return createQuestionCardAiCopy(t);
};
